export default __webpack_public_path__ + "static/media/Discord - Icon.c342c01d.svg";